import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const downtownTampaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Downtown Tampa Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Downtown Tampa, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_downtown_tampa',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Downtown Tampa',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Downtown Tampa Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we handle tree work in the fast paced, 
     densely built environment of <strong>Downtown Tampa</strong>. Urban tree care 
     requires a different level of precision trees growing close to commercial 
     buildings, pedestrian areas, parking structures, and utility infrastructure 
     demand expert handling and careful execution. Our team operates confidently 
     in tight urban settings and gets the job done safely.`,

    `We specialize in <strong>urban and commercial tree removal and trimming</strong> 
     trees threatening building facades and overhead utilities, storm damaged trees 
     in high traffic areas, overgrown canopies near parking lots and loading zones, 
     and emergency response cleanup after severe weather events. We coordinate 
     around your schedule and minimize disruption.`,

    `<strong>Sam's Tree Service</strong> delivers reliable, professional tree care 
     throughout <strong>Downtown Tampa</strong> and across the 
     <strong>Tampa urban core</strong> keeping commercial and residential 
     properties safe and compliant year round.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Downtown Tampa, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_DowntownTampa = () => <LocationPage config={downtownTampaConfig} />;
export default Services_DowntownTampa;
